import {dispatchAction} from "../../state/dispatchAction";
import {setConnectionStatus} from "../../../reducers/configSlice";
import {SOCKET_DISCONNECTED} from "../../../constants/default";

export const handleDisconnect = (socket) => (reason) => {
    dispatchAction(setConnectionStatus(SOCKET_DISCONNECTED))

    if (reason !== 'io client disconnect') {
        setTimeout(() => {
            socket.connect();
        }, 1000);
    }
};